<template>
  <div class="offer-info-block">
    <validation-observer
      ref="main_form"
      v-slot="{ validated }"
    >
      <b-row>
        <b-col
          cols="12"
          style="background: #fff"
        >
          <b-row style="padding-bottom: 0.857rem;">
            <b-col cols="12">
              <label>{{ $t('apps.surveyPostbackUrl') }}</label>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                :name="$t('apps.surveyPostbackUrl')"
                vid="Survey Postback URL"
                :rules="{ required: (is_resend_failed_webhooks === 1 || is_postback_on_reconciliations === 1) && (!offer_postback_url || offer_postback_url.trim() === '') }"
              >
                <b-input
                  v-model="postback_url"
                />
                <small
                  v-if="showAtLeastOnePostbackError && validated"
                  class="text-danger"
                >{{ $t('apps.pleaseEnterAtLeastOnePostbackUrlSurveyOr') }}</small>
                <small
                  v-else-if="(is_resend_failed_webhooks === 1 || is_postback_on_reconciliations === 1) && validated && errors.length > 0"
                  class="text-danger"
                >{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              class="mb-50"
            >
              <div class="offer-info-block-des">
                {{ $t('apps.serverToServerWebhookToProcessSurveyRewardsOn') }}
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          style="background: #fff"
        >
          <b-row style="padding-bottom: 0.857rem;">
            <b-col cols="12">
              <label>{{ $t('apps.offerPostbackUrl') }}</label>
            </b-col>
          </b-row>
          <b-row style="margin-bottom: 2.286rem;">
            <b-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                :name="$t('apps.offerPostbackUrl')"
                vid="Offer Postback URL"
                :rules="{ required: (is_resend_failed_webhooks === 1 || is_postback_on_reconciliations === 1) && (!postback_url || postback_url.trim() === '') }"
              >
                <b-input
                  v-model="offer_postback_url"
                />
                <small
                  v-if="showAtLeastOnePostbackError && validated"
                  class="text-danger"
                >{{ $t('apps.pleaseEnterAtLeastOnePostbackUrlSurveyOr') }}</small>
                <small
                  v-else-if="(is_resend_failed_webhooks === 1 || is_postback_on_reconciliations === 1) && validated && errors.length > 0"
                  class="text-danger"
                >{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          style="background: #fff"
          cols="6"
        >
          <b-form-checkbox
            v-model="is_resend_failed_webhooks"
            class="mr-1"
            :value="1"
            :unchecked-value="0"
          >
            <div class="mx-50">
              <b>{{ $t('apps.resendFailedWebhooksRecommended') }}</b><br>
              {{ $t('apps.ifYourServerRespondsWithANonSuccessCode') }}

              <div class="block-warning-unique-id font-weight-bold mt-50">
                {{ $t('apps.youMustEnsureThatYouProcessEachTxId') }}
              </div>
            </div>
          </b-form-checkbox>

          <b-form-checkbox
            v-model="is_postback_on_reconciliations"
            class="mr-1 mt-2"
            :value="1"
            :unchecked-value="0"
          >
            <div class="mx-50">
              <b>{{ $t('apps.reconciliationWebhooks') }}</b><br>
              <i18n
                path="apps.reconciliationAmounts"
                tag="span"
              >
                <b slot="reward">{reward}</b>
                <b slot="payout">{payout}</b>
              </i18n><br>
              <i18n
                path="apps.reconciliationTransaction"
                tag="span"
              >
                <b slot="transactionId">{tx_id}</b>
              </i18n>
            </div>

          </b-form-checkbox>

          <div class="block-attention mb-2">
            {{ $t('apps.ourPostbackCallsWillComeFromTheFollowingIp') }}
            <b-form-textarea
              :value="`168.119.57.82\n49.12.33.196\n49.13.14.251`"
              readonly
              rows="3"
              class="bg-white w-50 text-right"
            />
          </div>
        </b-col>
        <b-col
          cols="6"
          style="background: #fff"
        >
          <b-row style="padding-bottom: 0.857rem;">
            <b-col cols="12">
              <label>{{ $t('apps.surveyPostbackParameters') }}</label>
            </b-col>
          </b-row>
          <table class="table b-table table-striped table-hover border">
            <thead>
              <tr>
                <th>{{ $t('apps.parameter') }}</th>
                <th>{{ $t('apps.type') }}</th>
                <th>{{ $t('apps.description') }}</th>
              </tr>
            </thead>
            <tbody role="rowgroup">
              <tr
                v-for="(tr, indextr) in supportedParameters"
                :key="indextr"
                @click="addParameter(tr)"
              >
                <td style="cursor: pointer">
                  {{ supportedParameters[indextr].key }}
                </td>
                <td>{{ supportedParameters[indextr].type }}</td>
                <td>
                  {{ supportedParameters[indextr].description }}
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>

        <b-col
          cols="6"
          class="py-2 px-3"
        >
          <div
            style="font-weight: 600; font-size: 1.143rem; line-height: 1.429rem;"
            class="mb-2"
          >
            {{ $t('apps.surveyPostbackTest') }}
          </div>
          <b-row class="mb-2">
            <b-col cols="6">
              <label for="test_unique_user_id">{{ $t('apps.uniqueUserId') }}</label>
              <b-form-input
                id="test_unique_user_id"
                v-model="test_unique_user_id"
                :placeholder="$t('apps.uniqueUserId')"
              />
            </b-col>
            <b-col cols="6">
              <label for="test_amount">{{ $t('apps.amount') }}</label>
              <b-form-input
                id="test_amount"
                v-model="test_amount"
                :placeholder="$t('apps.amount')"
                type="number"
                :min="test_click_type === 4 ? -1000 : 0"
              />
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="6">
              <label for="test_tx_id">{{ $t('apps.transactionId') }}</label>
              <b-form-input
                id="test_tx_id"
                v-model="test_tx_id"
              />
            </b-col>
            <b-col cols="6">
              <label for="test_subid">{{ $t('apps.subid') }}</label>
              <b-form-input
                id="test_subid"
                v-model="test_subid"
              />
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="6">
              <label for="userRewardAmount">{{ $t('apps.userReward') }}</label>
              <b-form-input
                id="userRewardAmount"
                :value="userRewardAmount"
                type="number"
                readonly
                :placeholder="$t('apps.userReward')"
              />
              <div style="font-size: 0.857rem; line-height: 1.143rem; margin-top: 0.857rem">
                {{ $t('apps.accordingToCurrencyConversionRate') }}
              </div>
            </b-col>
            <b-col cols="6">
              <label>{{ $t('apps.type') }}</label>
              <b-radio-group
                v-model="test_click_type"
                style="margin-top: 0.429rem; gap: 10px; display: grid;"
                @change="onClickTypeChange"
              >
                <b-radio :value="1">
                  {{ $t('apps.complete') }}
                </b-radio>
                <b-radio :value="2">
                  {{ $t('apps.screenout') }}
                </b-radio>
                <b-radio :value="3">
                  {{ $t('apps.bonus') }}
                </b-radio>
                <b-radio :value="4">
                  {{ $t('apps.reconciliation') }}
                </b-radio>
              </b-radio-group>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="12">
              <b-button
                variant="primary"
                @click="test_postback()"
              >
                {{ $t('apps.testPostback') }}
              </b-button>
            </b-col>
          </b-row>
          <div style="font-weight: 600; font-size: 1.143rem; line-height: 1.429rem; margin: 1.714rem 0">
            {{ $t('apps.postbackResults') }}
          </div>
          <b-row>
            <b-col cols="8">
              <label style="margin-bottom: 0.857rem">{{ $t('apps.postbackUrlFired') }}</label>
              <b-input
                v-model="test_fired_url"
                readonly="readonly"
                style="background-color: #FFF; margin-bottom: 0.857rem;"
              />
              <div>{{ test_description }}</div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="12">
              <div
                v-if="test_status_code >= 0"
                style="text-align: center"
                :class="test_status_class"
              >
                <div class="w-full">
                  <b style="font-size: 1.286rem">{{ test_status_code }}</b>
                </div>
                <div
                  v-if="test_status_text != ''"
                  class="w-full"
                >
                  {{ test_status_text ? $t('system.success') : '' }}
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>

        <b-col
          cols="6"
          style="background: #fff"
        >
          <b-row style="padding-bottom: 0.857rem;">
            <b-col cols="12">
              <label>{{ $t('apps.offersGamesParameters') }}</label>
            </b-col>
          </b-row>
          <table class="table b-table table-striped table-hover border">
            <thead>
              <tr>
                <th>{{ $t('apps.parameter') }}</th>
                <th>{{ $t('apps.type') }}</th>
                <th>{{ $t('apps.description') }}</th>
              </tr>
            </thead>
            <tbody role="rowgroup">
              <tr
                v-for="(tr, indextr) in offersGamesParameters"
                :key="indextr"
                @click="addParameter(tr)"
              >
                <td style="cursor: pointer">
                  {{ offersGamesParameters[indextr].key }}
                </td>
                <td>{{ offersGamesParameters[indextr].type }}</td>
                <td>
                  {{ offersGamesParameters[indextr].description }}
                </td>
              </tr>
            </tbody>
          </table>

        </b-col>

        <b-col
          cols="6"
          style="background: #fff"
        />
      </b-row>
    </validation-observer>
  </div>
</template>

<script>
import i18n from '@/libs/i18n'

import { ValidationObserver, ValidationProvider } from 'vee-validate/dist/vee-validate.full'

export default {
  components: { ValidationObserver, ValidationProvider },
  props: ['value'],
  data() {
    return {
      postback_url: '',
      offer_postback_url: '',
      is_resend_failed_webhooks: this.value.is_resend_failed_webhooks,
      is_postback_on_reconciliations: this.value.is_postback_on_reconciliations,
      mounted: false,
      supportedParameters: [
        {
          key: '{reward}',
          type: 'Integer',
          get description() { return i18n.t('apps.theAmountOfInAppCurrencyThatShouldBe') },
        },
        {
          key: '{payout}',
          type: 'Integer',
          get description() { return i18n.t('apps.publisherPayoutInUsd') },
        },
        {
          key: '{type}',
          type: 'Integer',
          get description() { return i18n.t('apps.1Complete2Screenout3Bonus4Reconciliation') },
        },
        {
          key: '{user}',
          type: 'String',
          get description() { return i18n.t('apps.uniqueUserId') },
        },
        {
          key: '{tx_id}',
          type: 'String',
          get description() { return i18n.t('apps.uniqueTransactionId') },
        },
        {
          key: '{subid}',
          type: 'String',
          get description() { return i18n.t('apps.returnsYourSubid') },
        },
        {
          key: '{reconciled_tx_id}',
          type: 'String',
          get description() { return i18n.t('apps.sameAsTheOriginalToIndicateAReconciliationTransaction', { transactionId: '{tx_id}' }) },
        },
      ],
      offersGamesParameters: [
        {
          key: '{user}',
          type: 'String',
          get description() { return i18n.t('apps.uniqueUserId') },
        },
        {
          key: '{tx_id}',
          type: 'String',
          get description() { return i18n.t('apps.uniqueTransactionId') },
        },
        {
          key: '{type}',
          type: 'Integer',
          get description() { return i18n.t('apps.eventType7Completed3BonusManualAttribution9') },
        },
        {
          key: '{payout}',
          type: 'Float',
          get description() { return i18n.t('apps.publisherPayoutInUsd') },
        },
        {
          key: '{platform}',
          type: 'String',
          get description() { return i18n.t('apps.platformWhereEventOccurredMobileTabletDesktop') },
        },
        {
          key: '{offer_name}',
          type: 'String',
          get description() { return i18n.t('apps.displayNameOfTheOffer') },
        },
        {
          key: '{offer_hash}',
          type: 'String',
          get description() { return i18n.t('apps.uniqueIdentifierHashForTheOffer') },
        },
        {
          key: '{task_name}',
          type: 'String',
          get description() { return i18n.t('apps.specificTaskOrMilestoneCompletedWithinTheOffer') },
        },
        {
          key: '{task_id}',
          type: 'String',
          get description() { return i18n.t('apps.uniqueIdentifierForTheSpecificTask') },
        },
        {
          key: '{ip_address}',
          type: 'String',
          get description() { return i18n.t('apps.userSIpAddressIpv4Only') },
        },
        {
          key: '{user_money_value}',
          type: 'Float',
          get description() { return i18n.t('apps.monetaryValueOfTheRewardGivenToTheUser') },
        },
        {
          key: '{user_currency}',
          type: 'String',
          get description() { return i18n.t('apps.currencyCodeForUserRewardEGUsdEur') },
        },
        {
          key: '{reward}',
          type: 'Integer',
          get description() { return i18n.t('apps.inAppCurrencyPointsRewardedToTheUser') },
        },
      ],
      test_unique_user_id: null,
      test_amount: null,
      test_user_reward: null,
      test_click_type: 1,
      test_status_class: null,
      test_status_code: -1,
      test_status_text: null,
      test_fired_url: '',
      test_tx_id: '',
      test_subid: '123abc',
      postbackHash: '',
    }
  },
  computed: {
    showAtLeastOnePostbackError() {
      const requiresPostback = this.is_resend_failed_webhooks === 1 || this.is_postback_on_reconciliations === 1
      const isSurveyEmpty = !this.postback_url || this.postback_url.trim() === ''
      const isOfferEmpty = !this.offer_postback_url || this.offer_postback_url.trim() === ''
      return requiresPostback && isSurveyEmpty && isOfferEmpty
    },
    urlHashingEnabled() {
      return [1, 2].includes(this.value.redirect_hash_type)
    },
    hashQueryString() {
      return this.value.redirect_hash_type === 2
    },
    postback_url_fired() {
      // Use the helper method to build the URL with parameters
      let postbackUrlFired = this.buildPostbackUrlWithParameters()

      // Add hash if URL hashing is enabled and hash is available
      if (this.urlHashingEnabled && postbackUrlFired && this.postbackHash) {
        postbackUrlFired += `&hash=${this.postbackHash}`
      }

      return postbackUrlFired
    },
    userRewardAmount() {
      let testAmount = this.test_amount === null ? 0 : parseFloat(this.test_amount)

      // Ensure testAmount is valid
      if (Number.isNaN(testAmount)) {
        testAmount = 0.0
      }

      const rewardAmount = this.value.currency_exchange_rate === null
        ? 0
        : parseInt(parseFloat(testAmount) * parseInt(this.value.currency_exchange_rate))

      // If the reward amount is NaN, or the rate is invalid, return 0
      if (Number.isNaN(rewardAmount)) {
        return 0
      }

      // If "Reconciliation" is selected, make the reward negative
      if (this.test_click_type === 4) {
        return -Math.abs(rewardAmount) // Ensure negative reward for Reconciliation
      }

      // For other cases, return the calculated reward, allowing positive values only
      return rewardAmount > 0 ? rewardAmount : 0
    },
    test_description() {
      if (this.test_status_code >= 0) {
        return i18n.t('apps.resultServerCode')
      }
      return i18n.t('apps.clickTestPostbackToCheckResult')
    },
  },
  watch: {
    postback_url() {
      const appData = this.value
      appData.postback_url = this.postback_url
      this.$emit('input', appData)
      // Regenerate hash when postback URL changes
      this.generatePostbackHash()
    },
    offer_postback_url() {
      const appData = this.value
      appData.offer_postback_url = this.offer_postback_url
      this.$emit('input', appData)
    },
    is_resend_failed_webhooks() {
      const appData = this.value
      appData.is_resend_failed_webhooks = this.is_resend_failed_webhooks
      this.$emit('input', appData)
    },
    is_postback_on_reconciliations() {
      const appData = this.value
      appData.is_postback_on_reconciliations = this.is_postback_on_reconciliations
      this.$emit('input', appData)
    },
    'value.postback_url': 'init_data',
    test_amount(newAmount) {
      // Force the test_amount to be negative when "Reconciliation" is selected
      if (this.test_click_type === 4 && newAmount > 0) {
        this.test_amount = -Math.abs(newAmount)
      }
      // Regenerate hash when amount changes
      this.generatePostbackHash()
    },
    test_unique_user_id() {
      this.generatePostbackHash()
    },
    test_tx_id() {
      this.generatePostbackHash()
    },
    test_subid() {
      this.generatePostbackHash()
    },
    test_click_type() {
      this.generatePostbackHash()
    },
    'value.redirect_hash_type': {
      handler() {
        this.generatePostbackHash()
      },
    },
  },
  mounted() {
    this.init_data()
    this.test_tx_id = this.generateRandomString(20)
    this.mounted = true
    // Generate initial hash
    this.generatePostbackHash()
  },
  methods: {
    onClickTypeChange() {
      // If Reconciliation is selected, make the amounts negative
      if (this.test_click_type === 4) {
        if (this.test_amount > 0) {
          this.test_amount = -Math.abs(this.test_amount) // Ensure negative amount
        }
      } else {
        // Reset amounts to positive if not Reconciliation
        this.test_amount = Math.abs(this.test_amount)
      }
    },
    reset_data() {
      this.$emit('reset', ['postback_url'])
    },
    init_data() {
      this.postback_url = this.value.postback_url
      this.offer_postback_url = this.value.offer_postback_url
      if (this.postback_url === null) this.postback_url = ''
      this.is_resend_failed_webhooks = parseInt(this.value.is_resend_failed_webhooks)
      this.is_postback_on_reconciliations = parseInt(this.value.is_postback_on_reconciliations)
    },
    test_postback() {
      if (
        (this.postback_url.indexOf('http://') !== 0
              && this.postback_url.indexOf('https://') !== 0)
      ) {
        this.alertError(i18n.t('apps.invalidUrl'))
        return
      }
      this.showLoading()
      this.$http.post('/api/apps/test-postback', {
        url: this.postback_url_fired,
      }).then(response => {
        const returnData = response.data
        this.test_status_code = returnData.code
        this.test_status_text = ''
        if (returnData.code === 200) {
          this.test_status_class = 'text-success'
          this.test_status_text = 'Success'
        } else if (returnData.code < 400) {
          this.test_status_class = 'text-warning'
        } else {
          this.test_status_class = 'text-danger'
        }
        this.test_fired_url = this.postback_url_fired
      }).catch(errors => {
        this.alertApiError(errors, i18n.t('apps.postbackTestFailed'))
      }).finally(() => {
        this.hideLoading()
      })
    },
    addParameter(param) {
      this.postback_url += param.key
    },
    generateRandomString(length) {
      const ALPHANUMERIC_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

      return Array.from({ length }, () => ALPHANUMERIC_CHARS.charAt(Math.floor(Math.random() * ALPHANUMERIC_CHARS.length))).join('')
    },
    buildPostbackUrlWithParameters() {
      // Build the postback URL with all parameters replaced
      let postbackUrlFired = this.postback_url || ''

      const userUniqueId = this.test_unique_user_id === null
        || this.test_unique_user_id.trim() === ''
        ? ''
        : encodeURIComponent(this.test_unique_user_id.trim())

      postbackUrlFired = postbackUrlFired.replaceAll('{user}', userUniqueId)
      postbackUrlFired = postbackUrlFired.replaceAll('{payout}', encodeURIComponent(this.test_amount))
      postbackUrlFired = postbackUrlFired.replaceAll('{reward}', encodeURIComponent(this.userRewardAmount))
      postbackUrlFired = postbackUrlFired.replaceAll('{type}', encodeURIComponent(this.test_click_type))
      postbackUrlFired = postbackUrlFired.replaceAll('{tx_id}', encodeURIComponent(this.test_tx_id))
      postbackUrlFired = postbackUrlFired.replaceAll('{reconciled_tx_id}', encodeURIComponent(`R=${this.test_tx_id}`))
      postbackUrlFired = postbackUrlFired.replaceAll('{subid}', encodeURIComponent(this.test_subid))

      return postbackUrlFired
    },
    async generatePostbackHash() {
      if (!this.urlHashingEnabled || !this.value.security_hash_salt) {
        this.postbackHash = ''
        return
      }

      // Use the helper method to build the URL with parameters
      const postbackUrlFired = this.buildPostbackUrlWithParameters()

      if (!postbackUrlFired) {
        this.postbackHash = ''
        return
      }

      let hashSource = ''

      // Determine what to hash based on redirect_hash_type
      if (this.hashQueryString) {
        // Hash only query string (redirect_hash_type === 2)
        try {
          const url = new URL(postbackUrlFired)
          hashSource = url.search
        } catch (e) {
          // If URL parsing fails, use empty hash
          this.postbackHash = ''
          return
        }
      } else {
        // Hash full URL (redirect_hash_type === 1)
        hashSource = postbackUrlFired
      }

      // Append security hash salt
      hashSource += this.value.security_hash_salt

      // Check if crypto.subtle is available (only in secure contexts)
      if (!window.crypto || !window.crypto.subtle) {
        console.warn('crypto.subtle is not available. Hash generation requires HTTPS.')
        this.postbackHash = ''
        return
      }

      // Use the Web Crypto API to generate a SHA-1 hash
      const encoder = new TextEncoder()
      const data = encoder.encode(hashSource)

      try {
        const hashBuffer = await window.crypto.subtle.digest('SHA-1', data)
        const hashArray = Array.from(new Uint8Array(hashBuffer))
        this.postbackHash = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('')
      } catch (err) {
        console.error('Hash generation failed:', err)
        this.postbackHash = ''
      }
    },
  },
}
</script>

<style scoped lang="scss">
.vs-dialog-text {
  overflow: auto;
  max-height: 14.286rem;
  word-break: break-all;
}

.vs-con-textarea {
  margin-bottom: 0.5rem;
}

.offer-info-block {
  background: #F8F8F8;
  border-radius: 0.429rem;
  margin-bottom: 0.857rem;

  label {
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 100%;
    color: #5E5873;
  }
}

.offer-info-block-des {
  font-style: normal;
  font-weight: normal;
  font-size: 0.857rem;
  line-height: 1.143rem;
  color: #6E6B7B;
  margin-top: 0.857rem;
  margin-bottom: 0.857rem;
}

.block-warning-unique-id {
  position: relative;
  background: rgba(234, 84, 85, 0.12);
  border-radius: 0.429rem;
  font-weight: 500;
  font-size: 1rem;
  line-height: 120%;
  color: #EA5455;
  padding: 0.857rem 1.214rem;
}

.block-attention {
  margin-top: 1.143rem;
  padding: 1.143rem;
  background: rgba(255, 159, 67, 0.12);
  border-radius: 0.429rem;
  font-size: 1rem;
  line-height: 140%;
}
</style>
